export const SHIPMENT_AMOUNT = "SHIPMENT_AMOUNT";
export const SHIPMENT_AMOUNT_SUCCESS = "SHIPMENT_AMOUNT_SUCCESS";
export const SHIPMENT_AMOUNT_FAIL = "SHIPMENT_AMOUNT_FAIL";

export const CREATE_PAYMENT_INTENT = "CREATE_PAYMENT_INTENT_INTENT";
export const CREATE_PAYMENT_INTENT_SUCCESS = "CREATE_PAYMENT_INTENT_SUCCESS";
export const CREATE_PAYMENT_INTENT_FAIL = "CREATE_PAYMENT_INTENT_FAIL";
